var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.866.33a.568.568 0 0 1 1.032 0l2.09 4.536a.4.4 0 0 0 .316.229l4.959.586a.568.568 0 0 1 .319.981l-3.668 3.39a.4.4 0 0 0-.121.372l.975 4.897a.567.567 0 0 1-.835.607l-4.356-2.442a.4.4 0 0 0-.39 0L3.83 15.927a.567.567 0 0 1-.834-.607l.975-4.897a.4.4 0 0 0-.121-.372L.182 6.662a.567.567 0 0 1 .32-.981l4.959-.586a.4.4 0 0 0 .316-.229z",
    clipRule: "evenodd"
  })));
};
export default SvgStar;